import { z } from 'zod';

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_AUDIENCE: z.string().min(1),
  VITE_URL_SERVICE: z.string().url(),
  // Optional: map renders without a token but shows a watermark warning.
  VITE_MAPBOX_TOKEN: z.string().optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const missingVariables = Object.keys(parsed.error.flatten().fieldErrors).join(', ');
  throw new Error(`Missing or invalid environment variables: ${missingVariables}`);
}

export const VITE_AUTH0_DOMAIN = parsed.data.VITE_AUTH0_DOMAIN;
export const VITE_AUTH0_CLIENT_ID = parsed.data.VITE_AUTH0_CLIENT_ID;
export const VITE_AUTH0_AUDIENCE = parsed.data.VITE_AUTH0_AUDIENCE;
export const VITE_URL_SERVICE = parsed.data.VITE_URL_SERVICE;
export const VITE_MAPBOX_TOKEN = parsed.data.VITE_MAPBOX_TOKEN ?? '';
